import { FlowSchedulingBlockConfigSchema } from 'flow-schema';
import { z } from 'zod';

import { BaseFlowBlockSchema, BlockType } from '../base/baseSchema.js';

export const SchedulingBlockSchema = BaseFlowBlockSchema.extend({
  type: z.literal(BlockType.Scheduling),
  config: FlowSchedulingBlockConfigSchema,
});
export type SchedulingBlock = z.infer<typeof SchedulingBlockSchema>;
